<template>
  <div class="country-input">
    <el-select
      v-model="state.country"
      class="country-select"
      :remote-method="filterCountry"
      filterable
      remote
      :placeholder="$t($props.holder)"
      :clearable="noTabSelect"
      @change="handleCountryChange"
      @clear="handleClear"
    >
      <template #prefix>
        <div class="country-prefix" :class="{ star: $props.isStar }">
          <slot name="prefix"></slot>

          <img
            v-if="state.country"
            class="country-flag"
            :src="require(`/public/flags/${state.country.toLowerCase()}.png`)"
            alt=""
          />
        </div>
      </template>

      <el-option
        v-for="item in state.countryList"
        :key="item.countryCode"
        :label="`${item.countryNameEn} - ${item.countryNameCn}`"
        :value="item.countryCode"
      >
        <div class="country-item">
          <img :src="require(`/public/flags/${item.countryCode.toLowerCase()}.png`)" />{{
            `${item.countryNameEn} - ${item.countryNameCn}`
          }}
        </div>
      </el-option>
    </el-select>
    <CountryPopover
      v-if="!noTabSelect"
      @change="handleCountryChange"
      :list="state.countryGroup"
      :country="state.country"
    />
  </div>
</template>

<script setup>
import { getCountryLetterGroup } from '@/apis/logistics'
import { defineEmits, defineProps, reactive, watch } from 'vue'
import CountryPopover from './CountryPopover.vue'

const $emit = defineEmits(['change'])
const $props = defineProps({
  holder: {
    type: String,
    default: 'estimation.holder.toCountry',
  },
  isStar: {
    type: Boolean,
    default: true,
  },
  country: {
    type: String,
  },
  noTabSelect: {
    type: Boolean,
    default: false,
  },
})
let countryList = []
const state = reactive({
  countryList: [],
  countryGroup: [],
  country: $props.country,
  long: undefined,
  width: undefined,
  height: undefined,
  weight: undefined,
  loading: false,
  timer: null,
  isClear: false,
})

// 获取国家群组数据
const getCountryGroupData = async () => {
  const res = await getCountryLetterGroup()
  countryList = res.reduce((acc, item) => {
    return acc.concat(item.countryList)
  }, [])
  state.countryGroup = res
  state.countryList = []
  state.country && handleCountryChange(state.country)
}
// 筛选搜索国家列表
const filterCountry = (query) => {
  if (state.timer) clearTimeout(state.timer)
  state.timer = setTimeout(() => {
    if (query) {
      state.countryList = countryList.filter((item) => {
        return (
          item.countryNameCn.toLowerCase().includes(query.toLowerCase()) ||
          item.countryNameEn.toLowerCase().includes(query.toLowerCase())
        )
      })
    } else {
      state.countryList = countryList
    }
    state.countryList = state.countryList.filter(
      (item, index) =>
        state.countryList.findIndex((i) => i.countryCode === item.countryCode) === index,
    )
    state.timer = null
  }, 200)
}
// 国家code变化
const handleCountryChange = async (code) => {
  state.country = code
  const item = countryList.find((item) => item.countryCode === code)
  $emit('change', item)
  setTimeout(() => {
    state.countryList = countryList
  }, 200)
}
const handleClear = () => {
  state.isClear = true
}

getCountryGroupData()

watch(
  () => $props.country,
  () => {
    if ($props.country === state.country) return
    state.country = $props.country
    state.country && handleCountryChange(state.country)
  },
)
</script>

<style lang="scss" scoped>
.country-input {
  width: 100%;
  height: 44px;
  position: relative;

  ::v-deep {
    .suffix {
      position: absolute;
      height: 44px;
      top: 0px;
      right: 10px;
    }
  }
}

.country-flag {
  width: 30px;
  border: 1px solid #f6f7fa;
}

.country-prefix {
  font-size: 14px;
  color: #666;

  &.star {
    &::before {
      content: '* ';
      color: red;
    }
  }
}

.country-select {
  margin-bottom: 14px;
}

// .country-select {
//   ::v-deep {
//     .el-select__input-wrapper {
//       float: right;
//       padding-right: 4px;
//     }
//   }
// }
::v-deep {
  .el-input__inner,
  .el-select-inner {
    // text-align: right;
  }

  .el-select__wrapper {
    // box-shadow: none;
  }

  .el-input-group__append {
    padding: 0;
  }

  .el-select__wrapper {
    height: 44px;
  }

  .country-item {
    img {
      width: 20px;
      margin-right: 4px;
    }
  }

  .el-select__placeholder {
    // color: #8492b2;
    // text-align: right;
    // float: right;
    // padding-right: 10px;
  }

  // .el-select__selection {
  //   float: right;
  //   display: block;
  //   width: 1px;
  // }
}
</style>
